// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"_1FBOTCTDk1tpvN0CWtJEGO","stampContainer":"_2dHjoWB7y4fjNlK-GGZIHV","informativeStampsContainer":"TLYGzXDnclJIHO_eFXkgD","label":"_3tC3I5ZkO3-9aTewxfaeGV"};